import { NGBackend } from './NGBackend';
const ngb = new NGBackend();
export { ngb, };
//# sourceMappingURL=index.js.map